import React, { useState, useEffect } from 'react';
import {
  TextField,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
  Button,
  Divider,
  Box
} from '@mui/material';

const DonorReactionForm = ({ onSubmit, initialData = {} }) => {
  const [form, setForm] = useState({
    symptomsVasodepressor: [],
    treatmentVasodepressor: { fluidAmount: '', other: '' },
    symptomsCitrate: [],
    citrateTumsCount: '',
    symptomsOther: [],
    daeRequired: null,
    attendingPersonnel: '',
    date: '',
    comment: '',
    fileCopy: null,
    qaReview: ''
  });

// Pre-fill form from initialData
  useEffect(() => {
    if (initialData) {
      setForm(prev => ({
        ...prev,
        ...initialData,
        treatmentVasodepressor: {
          fluidAmount: initialData?.treatmentVasodepressor?.fluidAmount || '',
          other: initialData?.treatmentVasodepressor?.other || ''
        }
      }));
    }
  }, [initialData]);

  const handleCheckboxGroup = (section, value) => {
    setForm(prev => {
      const list = prev[section] || [];
      const updated = list.includes(value)
        ? list.filter(item => item !== value)
        : [...list, value];
      return { ...prev, [section]: updated };
    });
  };

  const handleSubmit = () => {
    if (onSubmit) onSubmit(form);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>Vasodepressor Reaction</Typography>
      <FormGroup row>
        {['Lightheaded', 'Dizzy', 'Weakness', 'Nausea', 'Pale skin', 'Sweating', 'Blurred Vision', 'Muscular Twitching', 'Vomiting', 'Loss of Consciousness'].map(label => (
          <FormControlLabel
            control={<Checkbox
              checked={form.symptomsVasodepressor.includes(label)}
              onChange={() => handleCheckboxGroup('symptomsVasodepressor', label)}
            />}
            label={label}
            key={label}
          />
        ))}
      </FormGroup>

      <TextField
        label="Other (explain)"
        fullWidth
        margin="normal"
        value={form.treatmentVasodepressor.other}
        onChange={e =>
          setForm(prev => ({
            ...prev,
            treatmentVasodepressor: {
              ...prev.treatmentVasodepressor,
              other: e.target.value
            }
          }))
        }
      />

      <TextField
        label="Fluids Offered (oz)"
        type="number"
        margin="normal"
        value={form.treatmentVasodepressor.fluidAmount}
        onChange={e =>
          setForm(prev => ({
            ...prev,
            treatmentVasodepressor: {
              ...prev.treatmentVasodepressor,
              fluidAmount: e.target.value
            }
          }))
        }
      />

      <Divider sx={{ my: 4 }} />

      <Typography variant="h5" gutterBottom>Citrate Reaction</Typography>
      <FormGroup row>
        {['Tingling around mouth and fingers', 'Muscular Cramps', 'Anxiety', 'Cooling Sensations', 'Shortness of breath', 'Stiffening and pointed downward hands or feet', 'If symptoms do not subside'].map(label => (
          <FormControlLabel
            control={<Checkbox
              checked={form.symptomsCitrate.includes(label)}
              onChange={() => handleCheckboxGroup('symptomsCitrate', label)}
            />}
            label={label}
            key={label}
          />
        ))}
      </FormGroup>

      <TextField
        label="Tums tablets given"
        type="number"
        margin="normal"
        value={form.citrateTumsCount}
        onChange={e => setForm({ ...form, citrateTumsCount: e.target.value })}
      />

      <Divider sx={{ my: 4 }} />

      <Typography variant="h5" gutterBottom>Other</Typography>
      <FormGroup row>
        {['Hematoma', 'Severe signs and symptoms not listed'].map(label => (
          <FormControlLabel
            control={<Checkbox
              checked={form.symptomsOther.includes(label)}
              onChange={() => handleCheckboxGroup('symptomsOther', label)}
            />}
            label={label}
            key={label}
          />
        ))}
      </FormGroup>

      <FormGroup row>
        <FormControlLabel
          control={<Checkbox
            checked={form.daeRequired === true}
            onChange={() => setForm({ ...form, daeRequired: form.daeRequired === true ? null : true })}
          />}
          label="DAE REPORT Required: Yes"
        />
        <FormControlLabel
          control={<Checkbox
            checked={form.daeRequired === false}
            onChange={() => setForm({ ...form, daeRequired: form.daeRequired === false ? null : false })}
          />}
          label="No"
        />
      </FormGroup>

      <TextField
        fullWidth
        label="Attending Personnel (Print Name)"
        margin="normal"
        value={form.attendingPersonnel}
        onChange={e => setForm({ ...form, attendingPersonnel: e.target.value })}
      />
      <TextField
        type="date"
        label="Date"
        fullWidth
        InputLabelProps={{ shrink: true }}
        margin="normal"
        value={form.date}
        onChange={e => setForm({ ...form, date: e.target.value })}
      />
      <TextField
        label="Comment"
        fullWidth
        multiline
        rows={3}
        margin="normal"
        value={form.comment}
        onChange={e => setForm({ ...form, comment: e.target.value })}
      />

      <FormGroup row>
        <FormControlLabel
          control={<Checkbox
            checked={form.fileCopy === true}
            onChange={() => setForm({ ...form, fileCopy: form.fileCopy === true ? null : true })}
          />}
          label="Copy placed in Donor Record File: Yes"
        />
        <FormControlLabel
          control={<Checkbox
            checked={form.fileCopy === false}
            onChange={() => setForm({ ...form, fileCopy: form.fileCopy === false ? null : false })}
          />}
          label="No"
        />
      </FormGroup>

      <TextField
        fullWidth
        label="QA Review (initials / date)"
        margin="normal"
        value={form.qaReview}
        onChange={e => setForm({ ...form, qaReview: e.target.value })}
      />

      <Box mt={4}>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Submit Form
        </Button>
      </Box>
    </Box>
  );
};

export default DonorReactionForm;
